import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { CheckCircleIcon, MinusCircleIcon } from '@fiverr-private/visuals';
import { ResponsiveDisplayType } from '@fiverr-private/theme/src/components/Box/types';
import { Tooltip } from '@fiverr-private/tooltip';
import { Gql } from '../../../types';

const matchIndicatorIcon: Record<Gql.DmBriefMatchIndicator['matchLevel'], React.ReactNode> = {
  FULL_MATCH: <CheckCircleIcon color="green_900" />,
  PARTIAL_MATCH: <CheckCircleIcon color="yellow_900" />,
  NO_MATCH: <MinusCircleIcon color="red_800" />,
};

export const MatchIndicator = ({
  matchIndicator,
  display,
  tooltipContent,
}: {
  matchIndicator: Gql.DmBriefMatchIndicator;
  display: ResponsiveDisplayType;
  tooltipContent?: React.ReactNode;
}) => {
  const content = tooltipContent ? <TooltipContent tooltipContent={tooltipContent} /> : undefined;
  return (
    <Container display={display}>
      {content ? (
        <Tooltip content={content}>{matchIndicatorIcon[matchIndicator.matchLevel]}</Tooltip>
      ) : (
        matchIndicatorIcon[matchIndicator.matchLevel]
      )}
    </Container>
  );
};

const TooltipContent = ({ tooltipContent }: { tooltipContent?: React.ReactNode }) => (
  <Stack direction="column" gap="0" fontWeight="normal" fontSize="b_sm" color="grey_100">
    {tooltipContent}
  </Stack>
);
